// Fonte única de labels/cores dos status do cadastro do entregador (Fase 4D/5).
// O backend calcula o status — aqui só apresentação.

export const REG_STATUS_META = {
  incomplete: { label: "Cadastro incompleto", color: "text-amber-400", bg: "bg-amber-500/15 border-amber-500/40", dot: "bg-amber-400" },
  pending: { label: "Em análise", color: "text-sky-400", bg: "bg-sky-500/15 border-sky-500/40", dot: "bg-sky-400" },
  approved: { label: "Cadastro aprovado", color: "text-emerald-400", bg: "bg-emerald-500/15 border-emerald-500/40", dot: "bg-emerald-400" },
  rejected: { label: "Cadastro reprovado", color: "text-red-400", bg: "bg-red-500/15 border-red-500/40", dot: "bg-red-400" },
  blocked: { label: "Conta bloqueada", color: "text-red-400", bg: "bg-red-500/15 border-red-500/40", dot: "bg-red-500" },
};

export const DOC_STATUS_META = {
  missing: { label: "Não enviado", chip: "bg-zinc-500/15 text-zinc-400 border-zinc-600/40" },
  pending: { label: "Em análise", chip: "bg-sky-500/15 text-sky-400 border-sky-500/40" },
  approved: { label: "Aprovado", chip: "bg-emerald-500/15 text-emerald-400 border-emerald-500/40" },
  rejected: { label: "Reprovado", chip: "bg-red-500/15 text-red-400 border-red-500/40" },
  expired: { label: "Vencido", chip: "bg-orange-500/15 text-orange-400 border-orange-500/40" },
};

export const DOC_LABELS = {
  cnh_front: "CNH — Frente",
  cnh_back: "CNH — Verso",
  selfie: "Selfie",
  liveness_video: "Vídeo de vivacidade",
  address_proof: "Comprovante de endereço",
  crlv: "CRLV",
};

export const VEHICLE_TYPE_LABELS = { moto: "Moto", carro: "Carro", bike: "Bicicleta" };

export const maskCpf = (cpf) => {
  const d = String(cpf || "").replace(/\D/g, "");
  if (d.length !== 11) return cpf || "—";
  return `${d.slice(0, 3)}.***.***-${d.slice(9)}`;
};

// Fallback local do menu server-driven (mesma estrutura do backend)
export const FALLBACK_DRIVER_MENU = [
  { key: "my_registration", label: "Meu cadastro", route: "/entregador/cadastro", icon: "clipboard-list", enabled: true, order: 1 },
  { key: "earnings", label: "Meus Ganhos", route: "/entregador/carteira", icon: "trending-up", enabled: true, order: 2 },
  { key: "wallet", label: "Carteira", route: "/entregador/carteira", icon: "wallet", enabled: true, order: 3 },
  { key: "map", label: "Mapa", route: "/entregador/mapa", icon: "map", enabled: true, order: 4 },
  { key: "chat", label: "Chat", route: "/entregador/chat", icon: "message-circle", enabled: true, order: 5 },
  { key: "missions", label: "Missões", route: "/entregador/perfil", icon: "flame", enabled: true, order: 6 },
  { key: "network", label: "Rede", route: "/entregador/rede", icon: "users", enabled: true, order: 7 },
  { key: "shop", label: "Lojinha", route: "/entregador/lojinha", icon: "shopping-bag", enabled: true, order: 8 },
  { key: "groups", label: "Nossos grupos", route: "/entregador/grupos", icon: "messages-square", enabled: true, order: 9 },
  { key: "support", label: "Suporte", route: "/suporte", icon: "headphones", enabled: true, order: 10 },
];
